import React from "react";
import css from "classnames";
import { QueryResult } from "@apollo/client";
import { RequestedCounts, RequestedCountsVariables, WaitlistUpdateRequestStatus } from "types/gql-types";
import { countByRequestedCountStatus } from "../utils";
import contentStyles from "./content.module.css";

const statusName = {
  [WaitlistUpdateRequestStatus.ALL_BOUNCED]: "All messages have bounced",
  [WaitlistUpdateRequestStatus.NO_RESPONSE]: "Has not yet responded",
  [WaitlistUpdateRequestStatus.RESPONDED]: "Responded",
  [WaitlistUpdateRequestStatus.UNREACHABLE]: "No contact information available",
  [WaitlistUpdateRequestStatus.UNREACHABLE_LANDLINE_ONLY]: "Landline only",
};

const groups = [
  {
    status: [
      WaitlistUpdateRequestStatus.UNREACHABLE_LANDLINE_ONLY,
      WaitlistUpdateRequestStatus.UNREACHABLE,
      WaitlistUpdateRequestStatus.ALL_BOUNCED,
    ],
    label: "Action required: Unable to contact",
  },
  { status: [WaitlistUpdateRequestStatus.NO_RESPONSE], label: "Pending" },
  { status: [WaitlistUpdateRequestStatus.RESPONDED], label: "Resolved" },
];

export const ContentCollapsed: React.FC<{
  setStatus: React.Dispatch<React.SetStateAction<WaitlistUpdateRequestStatus | null>>,
  countResults: QueryResult<RequestedCounts, RequestedCountsVariables>
}> = ({ setStatus, countResults }) => {
  if (countResults.error || countResults.loading) return null;

  const requestedCounts = countResults.data?.interestList.scheduledUpdate.requestedCounts || [];

  return <div>
    {groups.map((group, index) => (
      <div key={index} className={contentStyles.group}>
        <div className={contentStyles.groupHeading}>
          <strong>
            {group.label}
            &nbsp;({countByRequestedCountStatus(requestedCounts, group.status).toLocaleString()})
          </strong>
        </div>
        <div>
          {group.status.map((status) => {
            const count = countByRequestedCountStatus(requestedCounts, [status]);
            return (
              <div
                key={status}
                onClick={() => count > 0 && setStatus(status)}
                className={css({
                  [contentStyles.subgroup]: true,
                  [contentStyles.empty]: count === 0,
                  [contentStyles.notEmpty]: count > 0,
                })}
              >
                <span>
                  {statusName[status]} ({count.toLocaleString()})
                </span>
              </div>
            );
          })}
        </div>
      </div>
    ))}
  </div>;
};
